var scrollPos = 0;
var scrollAnimate = require('base/components/scrollAnimate');
window.addEventListener('scroll', function () {
    $('header').css('position', 'absolute');
    if ((document.body.getBoundingClientRect()).top > scrollPos && scrollPos <= -78) {
        $('header').removeAttr('style');
        $('header').addClass('sticky-header');
    } else {
        $('header').removeClass('sticky-header');
    }
    scrollPos = (document.body.getBoundingClientRect()).top;

     //  Back to Top
    var headerHeight = $('header').height();
    var breadCrumbHeight = $('.product-breadcrumb').height();
    var filterHeight = $('.plp-quick-filters-section').height();
    var gridHeight = $('.grid-header').height();
    var searchResultHeight = $('.category-search-results').height();

    var heightOfFold = headerHeight + breadCrumbHeight + searchResultHeight + gridHeight +  filterHeight;
    if($('.occasionContainer').length){
         (heightOfFold = heightOfFold + $('.occasionContainer').height() + ($('.product').height()*2))
    } else {
        (heightOfFold = heightOfFold + ($('.product').height()*3));
    }
    
    if (($(window).scrollTop() > heightOfFold)) {
        $('.move-to-top').addClass('show');
    } else {
        $('.move-to-top').removeClass('show');
    } 
});

// Safe MartJack stub to avoid "MartJack is not defined" errors
(function () {
  // Only create the stub if MartJack is completely missing
  if (typeof window.MartJack === 'undefined') {
    window.MartJack = {
      Current: {
        User: {
          // GTM code expects `.UserID`
          UserID: null
        }
      },
      Config: {
        // GTM code expects `.Config.MerchantId`
        MerchantId: null
      }
    };
  } else {
    // Optional: ensure nested objects exist even if MartJack is partially defined
    window.MartJack.Current = window.MartJack.Current || {};
    window.MartJack.Current.User = window.MartJack.Current.User || { UserID: null };
    window.MartJack.Config = window.MartJack.Config || { MerchantId: null };
  }
})();

$(document).on('click', '.mobile-utility-links .fa-search', function () {
    $('header .search-mobile').slideToggle();
});

if ($(window).width() < 768) {
    if (!$('.whatsApp-chat-mobile-nav .whatsapp-chat').length) {
        $('.whatsapp-chat').clone().appendTo('.whatsApp-chat-mobile-nav');
    }
}

const updateWishlistonPLP = () => {
    let wishlistUrl = $(document).find('#wishlist-map-url').data('url');
    let productObject = $(document).find('.product-grid .product');
    if($(document).find('.tile-body').length > 0){
        $('.product-tile .js-btn-wishlist .fa-heart').removeClass('fa-heart').addClass('fa-heart-o');
        $('.product-tile .js-btn-wishlist').addClass('wishlistTile').removeClass('remove-from-wishlist');
    }
  
    $.ajax({
        url: wishlistUrl,
        type: 'get',
        dataType: 'json',
        success(data) {
            let wishlistMap = data.wishlistMap;
            wishlistMap.forEach(pid => {          
                $('.product-tile[data-pid="' + pid + '"]').find('.js-btn-wishlist').addClass('remove-from-wishlist').removeClass('wishlistTile');
                $('.product-tile[data-pid="' + pid + '"]').find('.js-btn-wishlist').find('.fa').removeClass('fa-heart-o').addClass('fa-heart');
            });
        },
        error(err) {
            // eslint-disable-next-line no-console
            console.log(err);
        },
    });
};

/* update wishlisted items on load of page */
$(window).on('load', () => {
    updateWishlistonPLP();
});

/* PLP Scroll To Top */

$(document).on('click', '.move-to-top', () => {
    scrollAnimate();
});


/*
    @Functionality - Read More and Read Less Text for footer content 
    @Author - Sanjeev Mishra
*/

function toggleEllipsis(){
    $('.read-more-link').addClass('d-none');
    $('.read-less-link').addClass('d-none');

    var el = $('.description-text');
    var divHeight = el.outerHeight();
    var lineHeight = 18;
    var lines = divHeight / lineHeight;
    if(lines >= 3 ){            
        el.addClass('ellipsis');
        el[0].style.webkitBoxOrient='vertical';
        $('.read-more-link').addClass('d-block').removeClass('d-none');
    }else{
        el.removeClass('ellipsis');
        $('.read-more-link').addClass('d-none').removeClass('d-block');
    }
}

toggleEllipsis();


$(document).on('click', '.read-more-link', function(){
    var pdiv = $(this).closest('div');
    pdiv.find('.description-text').removeClass('ellipsis').css('margin-bottom','0');
    pdiv.find('.description-text')[0].style.webkitBoxOrient='vertical';
    pdiv.find('.read-more-link').addClass('d-none').removeClass('d-block');
    pdiv.find('.read-less-link').addClass('d-block').removeClass('d-none');
});

$(document).on('click', '.read-less-link', function(){
    var pdiv = $(this).closest('div');
    pdiv.find('.description-text').addClass('ellipsis');
    pdiv.find('.read-more-link').addClass('d-block').removeClass('d-none');
    pdiv.find('.read-less-link').addClass('d-none').removeClass('d-block');
});


$(document).on('click', '.to-checkout-btn', function () {
    sessionStorage.setItem('movingToCheckout', true);
});

$('#signup-login-popup .close').on('click', function () {
    sessionStorage.setItem('movingToCheckout', false);
    $('.guest-checkout-login-button-container').addClass('d-none');
});

$('#signup-login-popup').on('hide.bs.modal', function () {
    sessionStorage.setItem('movingToCheckout', false);
    $('.guest-checkout-login-button-container').addClass('d-none');
});

$(document).on('click', '.order-product-summary .fa.fa-plus', function () {
    $('.product-summary-block').slideDown();
    $(this).hide();
    $('.order-product-summary .fa.fa-minus').show();
});

$(document).on('click', '.order-product-summary .fa.fa-minus', function () {
    $('.product-summary-block').slideUp();
    $(this).hide();
    $('.order-product-summary .fa.fa-plus').show();
});

$(document).on('click', '.eye-icon',function () {
    $(this)
        .prev()
        .attr('type', (index, attr) => (attr === 'text' ? 'password' : 'text'));
    if ($(this).find('.fa-light').hasClass('fa-eye-slash')) $(this).find('.fa-eye-slash').removeClass('fa-eye-slash').addClass('fa-eye');
    else $(this).find('.fa-eye').removeClass('fa-eye').addClass('fa-eye-slash');
});

$(document).on('blur', 'input.form-control', function() {
    var selectedField = $(this);
    if (selectedField.val() !== '') {
        selectedField.siblings('.form-control-label').addClass("animate-label");
    } else {
        selectedField.siblings('.form-control-label').removeClass("animate-label");
    }
}) ;

/**
 * Submits the newsletter form to the NewsLetter-Subscribe route
 * @param {JQuery} $form - the login form as a jQuery object
 * @param {string} url - the NewsLetter-Subscribe route's url
 */
function newsletterSubscribe($form, url) {
    let customerId = $('form[name="newsletter"] :input[name="subscribeEmail"]').data('customerid')?$('form[name="newsletter"] :input[name="subscribeEmail"]').data('customerid'): '';
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function(data) {
            $.spinner().stop();
            if (data.error) {
                $('.input-error').removeClass('d-none').addClass('d-block').find('p').text(data.msg);
            } else {
                $('form[name="newsletter"] :input[name="subscribeEmail"]').val('');
                $('.input-success').removeClass('d-none').addClass('d-block').find('p').text(data.msg);
                window.dataLayer.push({
                    event: "Newsletter_Signup",
                    click_text: "email_subscribed",
                    user_id: customerId,
                    nextPage:window.location.href, 
                    currentPage: window.location.href 
                });
            }
            setTimeout(function() {
                $('.newsletter-feedback.d-block').removeClass('d-block');
                $('.newsletter-feedback.input-error, .newsletter-feedback.input-success').addClass('d-none');
            }, 3000);
        },
        error: function(err) {
            $.spinner().stop();
            $('.input-error').removeClass('d-none').addClass('d-block').find('p').text(err.responseJSON.message);
            setTimeout(function() {
                $('.newsletter-feedback.d-block').removeClass('d-block');
                $('.newsletter-feedback.input-error').addClass('d-none');
            }, 3000);
        }
    });
}

$('form[name="newsletter"]').submit(function (e) {
    e.preventDefault();
    let $form = $(this);
    let url = $form.attr('action');
    $.spinner().start();
    let $recaptcha = $(this).find('[name="g-recaptcha-response"]');
    if ($recaptcha.length) {
        let siteKey = $recaptcha.data('sitekey');
        let action = $form.find('[name="g-recaptcha-action"]').val();
        grecaptcha.execute(siteKey, { action: action }).then(function (token) {
            $recaptcha.val(token);
            newsletterSubscribe($form, url);
        });
    } else {
        newsletterSubscribe($form, url);
    }
});

/* 
    on click footer links check if user logged in - redirect to the page else open login modal 
*/

function gtmDataLayersPush(events, elementVal, section_clicked, mainHeader, subHeader, nextPage, currentPage,customerId) {
    window.dataLayer.push({
        event: events,
        click_text: elementVal,
        section_clicked: section_clicked,
        link_header: mainHeader,
        userID:customerId,
        link_sub_header: subHeader,
        nextPage: nextPage,
        currentPage: currentPage,

    });
}

$(document).on('click', '.footer-link', function(e) {
    e.preventDefault();
    let elementVal = $(this).html();
    let mainHeader = $(this).closest('.content-asset ').find('.title').html();
    if (mainHeader == undefined) {
        mainHeader = 'root';
    }
    let subHeader = elementVal;
    let nextPage = $(this).attr('href');
    let currentPage = window.location.href;
    let url = $('#customerNoUrl').val();
    let customerId="";

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            gtmDataLayersPush("Footer_Navigation", elementVal, "Footer_Navigation", mainHeader, subHeader, nextPage, currentPage,customerId);
        }
    });

    if (!$(".js-logged").hasClass("user-logged-in")) { 
        $('.login-modal-render:not(.to-checkout-btn)').trigger('click');
        $('footer').attr('data-url', $(this).attr('href'));
    } else {
        window.location.href = nextPage;
    }

});

$(document).on('click', '.swatches a', function (e){
    e.preventDefault();
    $(this).closest('.tile-body').siblings('.product-tile').find('.quickview').trigger('click');
});


/* code for update top padding as per content */
window.addEventListener('load', updatePadding);
window.addEventListener('resize', updatePadding);

function updatePadding() {
    if (document.querySelector('.homepage')) return;
    if (document.querySelector('.show-fixed-transparent-header')) return;

    var header = document.querySelector('header');
    var main = document.getElementById('maincontent');

    if (header && main) {
        main.style.paddingTop = header.offsetHeight + 'px';
    }
}

if($('.add-to-cart-global').is(':disabled')) {
    $('.disabled-button-pdp').show();
} else {
    $('.disabled-button-pdp').hide();
}

$(document).on('click', '.disabled-button-pdp', function() {
    $(this).closest(".product-detail").find('.size-not-selected-error').removeClass('d-none');
    if (!$(this).parents('.product-detail').hasClass('product-quickview')) {
        $('html, body').animate({
            scrollTop: $(this).closest(".product-detail").find(".color-swatch-area").offset().top
        }, 500);
    }
});

if (window.location.hash === "#_=_"){
    history.replaceState ? history.replaceState(null, null, window.location.href.split("#")[0]) : window.location.hash = "";
}

$(document).on('submit', '.trackorder', function(e) {
        let orderID = $('#trackorder-form-number').val();
        let url = $('#customerNoUrl').val();
        let customerId='';  
        if (orderID) {    
            $.ajax({
                url: url,
                dataType: 'json',
                method: 'GET',
                success(data) {
                    //if(data.customerId){
                        customerId = data.customerId;
                        window.dataLayer.push({
                            event: "Track_Order",
                            click_text: orderID,
                            currentPage: window.location.href,
                            nextPage: $('.trackorder').attr('action'),
                            userID: customerId
                            }
                        );
                    //}
                },
            });
        }
});

$('.less-more-text').each(function() {
    var $this = $(this);
    var text = $this.text();
    var truncatedText = text.substr(0, 120);

    if (text.length > 120) {
        $this.html(truncatedText + '<span class="more-ellipses">... <span class="more-link toggle-link">View more</span></span><span class="more-text">' + text.substr(120) + ' <span class="more-link toggle-link">View Less</span></span>');
    }
});

$(document).on('click', '.toggle-link', function() {
    var $this = $(this);
    var moreText = $this.closest('.less-more-text').find('.more-text');
    var ellipses = $this.closest('.less-more-text').find('.more-ellipses');
    if (moreText.is(':visible')) {
        moreText.hide();
        ellipses.show();
    } else {
        moreText.show();
        ellipses.hide();
    }
});

$(document).on('change', '#countryCode', function() {
  var zipDisabledCountries = $(this).data('zipdisabledcountries');
  var selectedValue = $(this).val();
  if(zipDisabledCountries !== undefined && zipDisabledCountries.length && zipDisabledCountries.includes(selectedValue)){
    $('label[for="zipcodedefault"]').closest('.form-group').removeClass('required');
  }else{
    $('label[for="zipcodedefault"]').closest('.form-group').addClass('required');
  }
});

$(document).on('change', '#country', function() {
    var zipDisabledCountries = $(this).data('zipdisabledcountries');
    var selectedValue = $(this).val();
    if(zipDisabledCountries !== undefined && zipDisabledCountries.length && zipDisabledCountries.includes(selectedValue)){
      $('label[for="zipCode"]').closest('.form-group').removeClass('required');
    }else{
      $('label[for="zipCode"]').closest('.form-group').addClass('required');
    }
  });

//   Handle Input Validation
document.addEventListener('input', function (event) {
  const el = event.target;

  // Alphabet only
  if (el.hasAttribute('data-input-alphabet-only')) {
    el.value = el.value.replace(/[^a-zA-Z ]/g, '');
  }

  // Number only
  if (el.hasAttribute('data-input-number-only')) {
    el.value = el.value.replace(/[^0-9]/g, '');
  }
});


module.exports = {
    updateWishlistonPLP,
};
